import React from "react";
import Careers from "../../../component/Operations/Careers";

const CareersScreen = () => {
  return (
    <div>
      <Careers />
    </div>
  );
};

export default CareersScreen;
